import React from "react";
import {
  FaBriefcase,
  FaBuilding,
  FaChartLine,
  FaUsers,
  FaHandshake,
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";

const PlacementPage = () => {
  const stats = [
    { value: "90%", label: "Placement Rate", icon: FaChartLine, color: "green" },
    { value: "50+", label: "Recruiters", icon: FaBuilding, color: "orange" },
    { value: "500+", label: "Students Placed", icon: FaUsers, color: "green" },
    { value: "8 LPA", label: "Highest Package", icon: FaBriefcase, color: "orange" },
  ];

  const recruiters = [
    "Tata Motors", "Mahindra & Mahindra", "BHEL", "Siemens", "L&T", "Havells",
    "BSES", "UPPCL", "Maruti Suzuki", "Ashok Leyland", "Voltas", "Schneider Electric"
  ];

  const processSteps = [
    { step: "01", title: "Registration", desc: "Students register with placement cell" },
    { step: "02", title: "Skill Assessment", desc: "Evaluate technical & soft skills" },
    { step: "03", title: "Pre-placement Training", desc: "Resume, aptitude, mock interviews" },
    { step: "04", title: "Company Drives", desc: "Campus recruitment & job fairs" },
    { step: "05", title: "Offer & Onboarding", desc: "Placement offer & joining support" },
  ];

  return (
    <section className="w-full overflow-hidden bg-gradient-to-br from-green-50 via-white to-orange-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-12 text-center">
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-md">
            <FaBriefcase className="h-5 w-5 text-green-600" />
            <span className="text-sm font-semibold text-gray-700">Career Opportunities</span>
          </div>
          <h1 className="mt-6 text-3xl font-extrabold text-gray-900 md:text-5xl">
            Placement <span className="text-green-600">Assistance</span>
          </h1>
          <p className="mx-auto mt-4 max-w-2xl text-base text-gray-600 md:text-lg">
            We connect students with top employers. Our dedicated placement cell ensures you
            launch your career with confidence.
          </p>
        </div>

        {/* Statistics Section */}
        <div className="mb-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="group rounded-2xl bg-white p-6 text-center shadow-md transition-all hover:scale-105 hover:shadow-xl"
            >
              <div className={`mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-${stat.color}-100 text-${stat.color}-600`}>
                <stat.icon className="h-7 w-7" />
              </div>
              <p className="text-3xl font-bold text-gray-800">{stat.value}</p>
              <p className="text-sm text-gray-500">{stat.label}</p>
            </div>
          ))}
        </div>
        <div className="mb-16 grid gap-12 lg:grid-cols-2">
          <div>
            <h2 className="mb-6 text-2xl font-bold text-gray-800 md:text-3xl">
              Our Placement <span className="text-orange-500">Process</span>
            </h2>
            <div className="space-y-4">
              {processSteps.map((item, idx) => (
                <div
                  key={idx}
                  className="group flex items-start gap-4 rounded-xl bg-white p-4 shadow-md transition-all hover:shadow-lg hover:translate-x-1"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-r from-green-600 to-orange-500 text-white font-bold">
                    {item.step}
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-800">{item.title}</h3>
                    <p className="text-sm text-gray-600">{item.desc}</p>
                  </div>
                  <FaArrowRight className="mt-2 h-4 w-4 text-gray-400 opacity-0 group-hover:opacity-100 transition" />
                </div>
              ))}
            </div>
          </div>
          <div>
            <h2 className="mb-6 text-2xl font-bold text-gray-800 md:text-3xl">
              Our Top <span className="text-green-600">Recruiters</span>
            </h2>
            <div className="rounded-2xl bg-white p-6 shadow-md">
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
                {recruiters.map((company, idx) => (
                  <div
                    key={idx}
                    className="flex items-center justify-center rounded-lg border border-gray-100 bg-gray-50 p-3 text-center text-sm font-medium text-gray-700 transition hover:border-green-300 hover:bg-green-50 hover:text-green-700"
                  >
                    {company}
                  </div>
                ))}
              </div>
              <div className="mt-6 text-center">
                <p className="text-sm text-gray-500">And many more... regular campus drives conducted</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mb-16 rounded-2xl bg-gradient-to-r from-green-50 to-orange-50 p-8 shadow-md">
          <div className="grid gap-8 md:grid-cols-2 items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 md:text-3xl">
                Pre-Placement <span className="text-green-600">Training</span>
              </h2>
              <ul className="mt-4 space-y-2">
                {[
                  "Resume building & LinkedIn optimization",
                  "Aptitude & reasoning preparation",
                  "Mock interviews by industry experts",
                  "Soft skills & communication workshops",
                  "Technical assessment & coding (if applicable)",
                ].map((item, idx) => (
                  <li key={idx} className="flex items-center gap-2">
                    <FaCheckCircle className="h-4 w-4 text-green-600" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="relative">
              <img
                src="image1.png"
                alt="Placement training"
                className="rounded-xl shadow-lg"
              />
            </div>
          </div>
        </div>
        <div className="rounded-3xl bg-gradient-to-r from-green-600 to-orange-500 p-8 text-center text-white shadow-xl">
          <h3 className="text-2xl font-bold md:text-3xl">Ready to Build Your Career?</h3>
          <p className="mt-2 text-lg opacity-90">Join ITI Bhaupur and get 100% placement assistance.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-4">
            <button className="rounded-full bg-white px-6 py-2 font-semibold text-green-600 shadow-md transition hover:scale-105">
              Apply Now
            </button>
            <button className="rounded-full border border-white px-6 py-2 font-semibold transition hover:bg-white hover:text-green-600">
              Contact Placement Cell
            </button>
          </div>
        </div>
      </div>
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeInUp {
          animation: fadeInUp 0.8s ease-out forwards;
        }
      `}</style>
    </section>
  );
};

export default PlacementPage;